export default "//uniclient-edge-assets.lmndstaging.com/star-rating-6dec761c3c97a967e162ef69fb12a0f2.riv"